/* Custom JavaScript */

// Review tooltip functionality
document.addEventListener("DOMContentLoaded", function() {
  const tip = document.getElementById("review-tooltip");
  if (!tip) return;

  // show after 5s on every page load
  setTimeout(() => {
    tip.classList.add("is-visible");
    tip.setAttribute("aria-hidden", "false");
  }, 5000);

  const closeBtn = tip.querySelector(".review-tooltip__close");
  const bodyBtn = tip.querySelector(".review-tooltip__body");

  // user closes it
  closeBtn.addEventListener("click", function(e) {
    e.stopPropagation();
    tip.classList.remove("is-visible");
  });

  // user clicks to read reviews
  bodyBtn.addEventListener("click", function() {
    tip.classList.remove("is-visible");
    // scroll happens automatically due to <a href>
  });
});
